import { TableColumn } from "@components/TableNew/TableColumns";
import { useMemo } from "react";
import { DescriptionCell, MenuItemNameCell, PriceCell, VenueCell } from "@pages/MenuExamples/MenuExamplesTableCells";
import { useSelector } from "react-redux";
import {
    currentCountrySelector,
    currentCurrencySelector,
    currentCurrencyStringSelector
} from "@selectors/countries.selector";

export const MENU_EXAMPLE_SORT_KEYS: Record<number, string | undefined> = {
    0: 'menuItemName',
    1: undefined,
    2: 'price',
    3: 'restaurantName',
};

export function useMenuExampleTableConfig(data: any[]) {
    const countryCode = useSelector(currentCountrySelector);
    const currencyValue = useSelector(currentCurrencyStringSelector);
    const currencySymbol = useSelector(currentCurrencySelector);

    const headStyle = useMemo(() => ({ fontSize: 14, fontWeight: 700 }), []);

    const columns: TableColumn[] = useMemo(() => [
        {
            key: 'menuItemName',
            head: 'Item',
            Value: ({ index }) => <MenuItemNameCell value={data[index]?.menuItemName} />,
            style: {
                cell: { flex: '0 0 20%' },
                head: headStyle,
            },
        },
        {
            key: 'description',
            head: 'Description',
            Value: ({ index }) => <DescriptionCell value={data[index]?.description} />,
            style: {
                cell: { flex: '0 0 55%' },
                head: headStyle,
            },
        },
        {
            key: 'price',
            head: `Price ${countryCode === "USA" ? "" : `(${currencyValue})`}`,
            Value: ({ index }) => <PriceCell price={data[index]?.price} currencySymbol={currencySymbol} />,
            style: {
                cell: { flex: '0 0 10%' },
                head: headStyle,
            },
        },
        {
            key: 'restaurantName',
            head: 'Venue',
            Value: ({ index }) => <VenueCell value={data[index]?.restaurantName} />,
            style: {
                cell: { flex: '0 0 15%', justifyContent: 'center', textAlign: 'center' },
                head: { ...headStyle, justifyContent: 'center' },
            },
            accentLevel: 1,
        },
    ], [countryCode, currencyValue, currencySymbol, data, headStyle]);

    return columns;
}